import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default () => {
  return {
    path: "switch-organization",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "org-switcher" */ "Login/components/OrganizationList"
          ),
        ]).then(([importedModule0]) => {
          const Component = importedModule0.default;
          return Component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
  };
};
